/**
 * @desc 删除redis缓存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/plmMaterialCategory/refreshCategoryKey`, {
      method: "GET",

      ...options,
    }),
  );
}
